import { useState } from 'react';
import { ProviderGroup } from '../../../../lib/helpers/SmartSendBulkActionApplier';
import OrderBookingStatusObserver from '../OrderBookingStatusObserver';
import ProviderGroupSummaryBookedLinks from './ProviderGroupSummaryBookedLinks';
import ProviderGroupSummaryBookedLabels from './ProviderGroupSummaryBookedLabels';
import { P2GAlert, P2GGrid, P2GText } from '@parcel2go/core-ui';
import { useTranslation } from 'react-i18next';
import { TranslationNamespaces } from '~/lib/constants';
import MarketplaceStatusObserver from '../MarketplaceStatusObserver';

interface props {
  group: ProviderGroup;
  markAsDispatched: () => void;
  confirmComponent: React.ReactNode;
}

const ProviderGroupSummaryBooked: React.FC<props> = (props) => {
  const [allBooked, setAllBooked] = useState(false);
  const [showAnyway, setShowAnyway] = useState(false);
  const allTrackingNumbersFound = () => setAllBooked(true);
  const customerWantsToTry = () => setShowAnyway(true);
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);
  const allBookedAndLinks = allBooked && props.group.ShipResponse?.Links?.length > 0;
  return (
    <P2GGrid container direction="column" spacing={2}>
      {(allBookedAndLinks || showAnyway) && (
        <P2GGrid item>
          <ProviderGroupSummaryBookedLabels group={props.group} />
          {!allBookedAndLinks && showAnyway && (
            <P2GAlert>
              <P2GText variant="body2">
                {t('PROVIDER_SUMMARY_BOOKED_LABELS_INFO', {
                  defaultValue: 'If your labels fail to load, please wait a few moments while we process your order.'
                })}
              </P2GText>
            </P2GAlert>
          )}
        </P2GGrid>
      )}
      <OrderBookingStatusObserver
        wrapper={(x) => <P2GGrid item>{x}</P2GGrid>}
        hasPaid={true}
        onAllTrackingNumbersGenerated={allTrackingNumbersFound}
        items={props.group.Items}
        onCustomerWantsToSeeTrackingNumbers={!showAnyway && customerWantsToTry}
      />
      <MarketplaceStatusObserver
        items={props.group.Items}
        markAsDispatched={props.markAsDispatched}
        wrapper={(x) => <P2GGrid item>{x}</P2GGrid>}
      />
      {(allBookedAndLinks || showAnyway) && (
        <>
          <P2GGrid item>
            <P2GGrid container direction="column" spacing={2}>
              <ProviderGroupSummaryBookedLinks group={props.group} />
            </P2GGrid>
          </P2GGrid>
          {props.confirmComponent && <P2GGrid item>{props.confirmComponent}</P2GGrid>}
        </>
      )}
    </P2GGrid>
  );
};

export default ProviderGroupSummaryBooked;
